import React, { useEffect, useState, useRef, createRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next'
import { createForm } from 'rc-form'
import { connect } from 'react-redux'

import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'

import { updateCreditCardSetting } from '../../actions/asyncMember'
import { cleanMemberStatus } from '../../actions/member'

const AddCreditCardDialog = props => {
    const { t } = useTranslation();
    const {
        form, open, onClose, onSucc,
        updateCreditCardFail, updateCreditCardSucc,
        cleanMemberStatus,
    } = props
    const [apiFailMsg, setApiFailMsg] = useState(false)
    const cardNoArr = [1,2,3,4]
    const cardNoRef = useRef(cardNoArr.map(() => createRef()));
    let cardNo_4 = 0

    const handleOnSubmit = () => {
        props.form.validateFields((error, value) => {
            if (!error) {
                const query = {
                    cardNo: `${value.cardNo_1}${value.cardNo_2}${value.cardNo_3}${value.cardNo_4}`,
                    cardExp: `${value.expiry_year}${value.expiry_month}`,
                    cardCvc: value.cvc
                }
                props.updateCreditCardSetting(query)
                cardNo_4 = value.cardNo_4
            }
        })
    }

    const handelClose = () => {
        setApiFailMsg(false)
        cleanMemberStatus()
        onClose()
    }

    useEffect(() => {
        if(updateCreditCardFail){
            setApiFailMsg(true)
        }
        if(updateCreditCardSucc){
            handelClose()
            onSucc(cardNo_4)
        }
    }, [updateCreditCardFail, updateCreditCardSucc])

    const autoFocusNextInput = (e) => {
        const elmt = e.target
        const idArr = elmt.id.split('_')
        const nextIdx = Number(idArr[1])
        if(elmt.value.length === elmt.maxLength && nextIdx < 4){
            cardNoRef.current[nextIdx].current.focus()
        }
    }

    const { getFieldProps, getFieldError } = form
    // const nameErr = getFieldError('name')
    const cardNo1Err = getFieldError('cardNo_1')
    const cardNo2Err = getFieldError('cardNo_2')
    const cardNo3Err = getFieldError('cardNo_3')
    const cardNo4Err = getFieldError('cardNo_4')
    const expiryMonthErr = getFieldError('expiry_month')
    const expiryYearErr = getFieldError('expiry_year')
    const cvcErr = getFieldError('cvc')

    return (
        <Dialog open={open} onClose={handelClose} fullWidth>
            <DialogTitle style={{ textAlign: 'right', paddingLeft: '32px', borderBottom: '1px solid rgba(74, 79, 85, 0.1)' }}>
                <Grid container justify="space-between" alignItems="center">
                    <Typography style={{ fontSize: '1.25rem', fontWeight: 500 }}>{t('add_credit_card')}</Typography>
                    <CloseIcon onClick={handelClose} style={{ cursor: 'pointer' }} />
                </Grid>
            </DialogTitle>
            <DialogContent style={{ padding: '32px' }}>
                <Grid container alignItems="center" style={{ marginBottom: '24px' }}>
                    <Grid item md={2} style={{ color: '#9fa2a3' }}>
                        <Typography style={{ color: '#9fa2a3' }}>{t('card_no')}</Typography>
                    </Grid>
                    <Grid item md={10}>
                        {cardNoArr.map((item, idx) => {
                            const id = `cardNo_${item}`
                            return (
                                <TextField
                                    key={id}
                                    margin="dense"
                                    name={id}
                                    id={id}
                                    variant="outlined"
                                    style={{ margin: '0 10px 0 0', width: '70px' }}
                                    inputRef={cardNoRef.current[idx]}
                                    inputProps={{
                                        maxLength: 4,
                                        ...getFieldProps(id, {
                                            initialValue: '',
                                            onChange: (e) => autoFocusNextInput(e),
                                            rules: [{
                                                required: true,
                                                type: 'string',
                                                pattern: /^[0-9]+$/,
                                                message: 'invalid card number'
                                            }]
                                        })
                                    }}
                                    error={
                                        (cardNo1Err && cardNo1Err !== null)
                                        || (cardNo2Err && cardNo2Err !== null)
                                        || (cardNo3Err && cardNo3Err !== null)
                                        || (cardNo4Err && cardNo4Err !== null)
                                    }
                                />
                            )
                        })}
                    </Grid>
                </Grid>
                <Grid container alignItems="center" style={{ marginBottom: '24px' }}>
                    <Grid item md={2}>
                        <Typography style={{ color: '#9fa2a3' }}>{t('expiry_date')}</Typography>
                    </Grid>
                    <Grid item>
                        <TextField
                            margin="dense"
                            name="expiry_month"
                            id="expiry_month"
                            variant="outlined"
                            style={{ margin: 0, width: '50px' }}
                            placeholder={t('month')}
                            inputProps={{
                                maxLength: 2,
                                ...getFieldProps('expiry_month', {
                                    initialValue: '',
                                    rules: [{
                                        required: true,
                                        type: 'string',
                                        pattern: /^[0-9]+$/,
                                        message: 'invalid expire month'
                                    }]
                                })
                            }}
                            error={expiryMonthErr && expiryMonthErr !== null}
                        />
                    </Grid>
                    <Grid item style={{ textAlign: 'center', margin: '0 16px' }}>/</Grid>
                    <Grid item>
                        <TextField
                            margin="dense"
                            name="expiry_year"
                            id="expiry_year"
                            variant="outlined"
                            style={{ margin: 0, width: '50px' }}
                            placeholder={t('year')}
                            inputProps={{
                                maxLength: 2,
                                ...getFieldProps('expiry_year', {
                                    initialValue: '',
                                    rules: [{
                                        required: true,
                                        type: 'string',
                                        pattern: /^[0-9]+$/,
                                        message: 'invalid expire year'
                                    }]
                                })
                            }}
                            error={expiryYearErr && expiryYearErr !== null}
                        />
                    </Grid>
                </Grid>
                <Grid container alignItems="center">
                    <Grid item md={2}>
                        <Typography style={{ color: '#9fa2a3' }}>{t('cvc')}</Typography>
                    </Grid>
                    <Grid item md={10}>
                        <TextField
                            margin="dense"
                            name="cvc"
                            id="cvc"
                            variant="outlined"
                            style={{ margin: 0 }}
                            placeholder={t('cvc_position')}
                            inputProps={{
                                maxLength: 3,
                                ...getFieldProps('cvc', {
                                    initialValue: '',
                                    rules: [{
                                        required: true,
                                        type: 'string',
                                        pattern: /^[0-9]+$/,
                                        message: 'invalid cvc'
                                    }]
                                })
                            }}
                            error={cvcErr && cvcErr !== null}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{
                padding: '16px 32px',
                margin: 0,
                borderTop: '2px solid rgba(74, 79, 85, 0.1)',
            }}>
                {apiFailMsg &&
                    <Typography color="error" variant="body2"
                        style={{position: 'absolute', left: '32px' }}>
                        {'*信用卡號碼無效'}
                    </Typography>
                }
                <Button color="primary" variant="contained" onClick={handleOnSubmit}>{t('save')}</Button>
            </DialogActions>
        </Dialog>
    )
}

const mapStateToProps = state => ({
    updateCreditCardFail: state.member.updateCreditCardFail,
    updateCreditCardSucc: state.member.updateCreditCardSucc,
})

const mapDispatchToProps = {
    updateCreditCardSetting,
    cleanMemberStatus,
};

AddCreditCardDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onSucc: PropTypes.func,
}

AddCreditCardDialog.defaultProps = {
    onSucc: () => {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(createForm()(AddCreditCardDialog))